export default __webpack_public_path__ + "static/media/geo_school_logo.f12b7214.png";